import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import './KabulEdilenler.css';

function KabulEdilenler() {
  const bildiriler = [
    { id: 1, kod: "İK1", ad: "Üretken Yapay Zeka Sonrası Sınıfta Öğrenmeyi Yönetmek: Bir Girişimcilik Dersi Vakası", yazar: "Prof. Dr. Deniz Tunçalp" },
    { id: 2, kod: "İK2", ad: "Kurumsal Eğitimlerde Oyunlaştırma Teknikleri Kullanımının Adanmışlık, Bilgi Tutma ve Algılanan Performans Üzerinde Etkisi", yazar: "Prof. Dr. Özge Tayfur Ekmekci, Bade Arık Kara" },
    { id: 3, kod: "İK3", ad: "Bireyi Tanıma Tekniklerinde Yapay Zeka Destekli Bir Yenilik Papbil’in Kariyer Planlaması ve İnsan Kaynakları Yönetimine Stratejik Etkisi", yazar: "Şaban Şahin, Öğr. Gör.Haci İsmail Çıngı, Lütfi Emre" },
    { id: 4, kod: "İK5", ad: "Etik İklim Çalışanı Nasıl Geliştirir? Örgütsel Etik İklimi, İşin Anlamlılığı ve İş Yerinde Gelişme (Thriving At Work) Arasındaki İlişkiler", yazar: "Arş. Gör. Edanur Çelik, Arş. Gör. Caner Günaydın, Prof. Dr. Vala Lale Tüzüner, Prof. Dr. Gönen İlkar Dündar" },
    { id: 5, kod: "İK6", ad: "Stratejik İnsan Kaynakları Endeksinin Radikal İnovasyona Etkisinde Dinamik Yeteneklerin Aracı Rolü", yazar: "Prof. Dr. Cemal Zehir, Dr. Öğr. Üyesi Emel Burak, Doç. Dr. Songül Zehir" }
  ];

  return (
    <div className="inner-page">
      <Navbar />
      
      <header className="page-hero">
        <div className="container">
          <h2>KABUL EDİLEN BİLDİRİLER</h2>
          <p>34. Ulusal Yönetim ve Organizasyon Kongresi</p>
        </div>
      </header>

      <main className="content-container" style={{ padding: '40px 0' }}>
        <div className="container">
          {/* Karşılama Mesajı */}
          <div className="announcement-text" style={{ marginBottom: '40px', lineHeight: '1.8' }}>
            <p>Değerli Bilim İnsanları ve Araştırmacılar,</p>
            <p>34. Ulusal Yönetim ve Organizasyon Kongresi’ne göstermiş olduğunuz yoğun ilgi ve alakanız için teşekkürlerimizi sunarız.</p>
            <p>Zamanın sizler için ne kadar önemli olduğunun farkındayız. Bu doğrultuda akademik heyecanınıza ortak olmak ve planlamalarınızı kolaylaştırmak amacıyla titizlikle yürütülen bildiri değerlendirme sonuçlarını vaktinden önce sizlerle paylaşıyoruz.</p>
            <p>Kongrede buluşmak dileğiyle..</p>
            
            <div style={{ marginTop: '20px', fontWeight: 'bold' }}>
              <p>Prof. Dr. Berrin FİLİZÖZ</p>
              <p>34. Ulusal Yönetim ve Org. Kongresi Dönem Başkanı</p>
            </div>
          </div>

          {/* Dosya İndirme Bölümü */}
          <div className="download-section" style={{ marginBottom: '30px', display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
            {/* Bildiri Listesi (DOCX) */}
            <a 
              href="/kabuledilen2.docx" 
              className="btn-download" 
              download
              style={{ display: 'inline-flex', alignItems: 'center', backgroundColor: '#2d3436', color: '#fff', padding: '12px 20px', borderRadius: '5px', textDecoration: 'none' }}
            >
              <i className="fas fa-file-word" style={{ marginRight: '10px' }}></i>
              Kabul Edilen Bildiriler Listesini İndir (.docx)
            </a>

            {/* Kongre Oturum Programı (PDF) */}
          
          </div>

          {/* Bildiri Tablosu */}
          <div className="table-responsive">
            <table className="table" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
              <thead style={{ backgroundColor: '#f8f9fa', textAlign: 'left' }}>
                <tr>
                  <th style={{ padding: '12px', borderBottom: '2px solid #dee2e6' }}>Sıra</th>
                  <th style={{ padding: '12px', borderBottom: '2px solid #dee2e6' }}>ID</th>
                  <th style={{ padding: '12px', borderBottom: '2px solid #dee2e6' }}>BİLDİRİ ADI</th>
                  <th style={{ padding: '12px', borderBottom: '2px solid #dee2e6' }}>Yazarlar</th>
                </tr>
              </thead>
              <tbody>
                {bildiriler.map((item) => (
                  <tr key={item.id}>
                    <td style={{ padding: '12px', borderBottom: '1px solid #dee2e6' }}>{item.id}</td>
                    <td style={{ padding: '12px', borderBottom: '1px solid #dee2e6' }}>{item.kod}</td>
                    <td style={{ padding: '12px', borderBottom: '1px solid #dee2e6' }}>{item.ad}</td>
                    <td style={{ padding: '12px', borderBottom: '1px solid #dee2e6' }}>{item.yazar}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <p style={{ marginTop: '15px', fontStyle: 'italic', color: '#666' }}>
              * Liste devam etmektedir. Tüm listeye ve güncel programa yukarıdaki butonlar üzerinden ulaşabilirsiniz.
            </p>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default KabulEdilenler;